import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = { instrument_full_loading : true, instrument_full_list: '', instrument_full_error: false};

export function instrumentListFull(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_INSTRUMENT:
        return {
            instrument_full_loading: true,
            instrument_full_list: '',
            instrument_full_error: false
        };
      case organisationConstants.RECIEVE_INSTRUMENT:
        return {
            instrument_full_loading: false,
            instrument_full_list: action.instruments.data,
            instrument_full_error: false
        };
      case organisationConstants.ERROR_INSTRUMENT:
        return { 
            instrument_full_loading: false,
            instrument_full_list: '',
            instrument_full_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/getInstrumentListFull.reducer.js